import { useSearchParams } from "react-router-dom";
import TransferRequestFlow from "@/features/transfers/transfer-request";
import { resolveTransferWizardStep } from "@/features/transfers/transfer-state";

export default function TransferNewPage() {
  const [searchParams] = useSearchParams();
  const step = searchParams.get("step") ?? undefined;
  return <TransferRequestFlow initialStep={resolveTransferWizardStep(step)} />;
}
